import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'Carlos M.',
    role: 'E-commerce Owner',
    text: 'Pensé que abrir mi LLC desde Colombia sería imposible. La guía de Inkova me ahorró meses de dolores de cabeza y miles en abogados.'
  }, {
    name: 'Laura V.',
    role: 'Freelancer',
    text: 'El paso a paso es increíblemente claro. Logré obtener mi EIN y abrir mi cuenta bancaria en USA sin tener que viajar.'
  }, {
    name: 'Diego R.',
    role: 'Agencia de Marketing',
    text: 'Compré la Ruta USA 360 y fue la mejor inversión. Evité multas que ni sabía que existían. 100% recomendado para latinos.'
  }];
  return <section className="py-24 bg-lavender-soft" id="testimonios" data-id="element-157">
      <div className="max-w-7xl mx-auto px-6" data-id="element-158">
        <div className="text-center max-w-2xl mx-auto mb-16" data-id="element-159">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-ink mb-4" data-id="element-160">
            Historias de <em className="italic text-accent-light" data-id="element-161">éxito</em>
          </h2>
          <p className="text-lg text-ink/70" data-id="element-162">
            Emprendedores que ya dieron el primer paso con nosotros.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-163">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-8 rounded-3xl shadow-soft border border-ink/5 flex flex-col h-full" data-id="element-164">
              <div className="flex gap-1 mb-6" data-id="element-165">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-accent text-accent" data-id="element-166" />)}
              </div>
              <p className="text-ink/80 text-lg mb-8 flex-grow" data-id="element-167">
                "{testimonial.text}"
              </p>
              <div data-id="element-168">
                <p className="font-bold text-ink" data-id="element-169">{testimonial.name}</p>
                <p className="text-sm text-ink/60 font-medium" data-id="element-170">
                  {testimonial.role}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}